import { createApiSlice } from "@common";
import {
    CRUD_PERSONAL_TITLE
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addPersonalTitle",
        method: "post",
        url: CRUD_PERSONAL_TITLE,
        stateKey: "message",
    },
    {
        name: "getPersonalTitle",
        method: "get",
        url: CRUD_PERSONAL_TITLE,
        stateKey: "data",
    },
    {
        name: "updatePersonalTitle",
        method: "put",
        url: CRUD_PERSONAL_TITLE,
        stateKey: "message",
    },
    {
        name: "deletePersonalTitle",
        method: "delete",
        url: CRUD_PERSONAL_TITLE,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "PersonalTitle",
    apiConfig,
    customReducers,
);
const PersonalTitleSlice = slice;
// Export the slice's reducer
export default PersonalTitleSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addPersonalTitle,
    getPersonalTitle,
    updatePersonalTitle,
    deletePersonalTitle
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
